import { Spinner } from ".";

export const FullPageSpinner = () => {
  return (
    <div className="flex h-screen justify-center items-center bg-black bg-opacity-50">
      <Spinner />
    </div>
  );
};
